// extracted by mini-css-extract-plugin
export default {"financialDetails":"usOnXtpDjD19kYALzGY8"};